// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-1BoXO","header":"header-3hkIx","body":"body-1PITw","footer":"footer-2DzQt","title":"title-2aP6z"};